<script setup lang="ts">
/**
 * MessageList — renderiza lista de mensagens com aria-live.
 * Mantém ordem cronológica. Sem indicadores de "está digitando..." (CC-04).
 *
 * HLOS-320: agora usa MessageBubble para cada mensagem, garantindo que
 * attachments (Fase 1) e ReadAloud (Fase 2) apareçam no feed.
 * Antes: renderizava inline, sem suporte a anexos/ReadAloud.
 */
import type { Message } from "../types";
import MessageBubble from "./MessageBubble.vue";

interface Props {
  messages: readonly Message[];
}

defineProps<Props>();
</script>

<template>
  <section
    class="hlos-message-list"
    data-testid="message-list"
    role="log"
    aria-live="polite"
  >
    <p v-if="messages.length === 0" data-testid="messages-empty">
      Inicie uma conversa digitando abaixo.
    </p>
    <ol v-else>
      <li v-for="msg in messages" :key="msg.id" :data-role="msg.role">
        <MessageBubble :message="msg" />
      </li>
    </ol>
  </section>
</template>

<style scoped>
.hlos-message-list {
  padding: 0.5rem 0;
  max-height: 60vh;
  overflow-y: auto;
}
ol {
  list-style: none;
  padding: 0;
  margin: 0;
}
li {
  padding: 0.4rem 0;
  opacity: 0.95;
}
</style>
